import JSONbig from 'json-bigint'
import { API_BASE } from './config.js'

const jsonParser = JSONbig({ storeAsString: true })

function getToken() {
  return localStorage.getItem('token') || ''
}

function request(method, path, body) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
  const options = {
    method,
    headers,
    credentials: 'include'
  }
  if (body !== undefined) {
    options.body = JSON.stringify(body)
  }
  return fetch(`${API_BASE}${path}`, options)
    .then(res => res.text())
    .then(text => jsonParser.parse(text))
}

/**
 * 创建标签
 * @param {Object} params
 * @param {number} params.projectId 所属项目 ID
 * @param {string} params.name 标签名称
 * @param {string} [params.color] 标签颜色（#RRGGBB）
 * @param {string} [params.icon] 标签图标
 * @returns {Promise<{code:number,message:string,data:Object,success:boolean,timestamp:string}>}
 */
export function createTag(params) {
  return request('POST', '/api/v1/tags', params)
}

/**
 * 获取项目的标签列表
 * @param {number} projectId 项目 ID
 * @returns {Promise<{code:number,message:string,data:Array,success:boolean,timestamp:string}>}
 */
export function listTagsByProject(projectId) {
  return request('GET', `/api/v1/tags/all?projectId=${projectId}`)
}

/**
 * 修改标签（名称 / 颜色 / 图标 / 排序号都可以只传要改的字段）
 * @param {number} tagId 标签 ID
 * @param {Object} params 同 createTag，但都可选
 * @returns {Promise<{code:number,message:string,data:Object,success:boolean,timestamp:string}>}
 */
export function updateTag(tagId, params) {
  return request('PUT', `/api/v1/tags/${tagId}`, params)
}

/**
 * 删除标签
 * @param {number} tagId 标签 ID
 * @returns {Promise<{code:number,message:string,data:null,success:boolean,timestamp:string}>}
 */
export function deleteTag(tagId) {
  return request('DELETE', `/api/v1/tags/${tagId}`)
}

/**
 * 统计标签被多少个时间块使用（**不限日期**，跨周统计）。
 *
 * 前端一次只加载一周，仅凭本地数据判断不出「该分类是否已被使用」，
 * 删除分类前必须问后端要真实总数。
 *
 * @param {number} tagId 标签 ID
 * @returns {Promise<{code:number,message:string,data:number,success:boolean,timestamp:string}>}
 */
export function getTagBlockCount(tagId) {
  return request('GET', `/api/v1/tags/${tagId}/block-count`)
}

/**
 * 删除标签并处置「引用该标签的全部时间块」（跨周，一次性由后端处理）。
 *
 * @param {number} tagId 标签 ID
 * @param {Object} params
 * @param {'DELETE_BLOCKS'|'TRANSFER'} params.strategy 处置策略
 * @param {number|string} [params.targetTagId] 转移目标标签 ID（strategy=TRANSFER 时必填）
 * @returns {Promise<{code:number,message:string,data:null,success:boolean,timestamp:string}>}
 */
export function removeTagWithBlocks(tagId, params) {
  return request('POST', `/api/v1/tags/${tagId}/remove`, params)
}
